import qualityEventsHelpers from '../quality-events.helpers';

type EventDetails = { id: number | string | undefined } & Record<string, unknown>;

export const MY_UPLOADS_QUALITY_EVENTS = {
    toggleWatermarkSettings(extra: string) {
        qualityEventsHelpers.track({
            type: 'toggleWatermarkSettings',
            extra
        });
    },
    featureMaterialInCabinet(itemId: number, extra: string) {
        qualityEventsHelpers.track({
            type: 'featureMaterialInCabinet',
            item_id: itemId,
            extra
        });
    },
    cabinetSurveyBannerClick() {
        qualityEventsHelpers.track({ type: 'cabinetSurveyBannerTypeformLinkClicked' });
    },
    bundleEvent(action: string, details: EventDetails) {
        qualityEventsHelpers.track({
            type: 'bundleEvent',
            source: action,
            item_id: details.id,
            extra: JSON.stringify({
                ...details
            })
        });
    },
    materialUpload(action: string, details: EventDetails) {
        qualityEventsHelpers.track({
            type: 'materialUploadEvent',
            source: action,
            item_id: details.id,
            extra: JSON.stringify({
                ...details
            })
        });
    },
    viewStatsInCabinet(kpiTypes: string[], selectedGrId: string, fromDate: Date, toDate: Date, materialId?: number) {
        qualityEventsHelpers.track({
            type: 'viewStatsInCabinet',
            item_id: materialId,
            extra: JSON.stringify({
                kpiTypes,
                granularity: selectedGrId,
                fromDate,
                toDate
            })
        });
    }
};
